import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchBoxComponent } from './search-box.component';
import { ButtonModule } from '@backbase/ui-ang/button';
import { IconModule } from '@backbase/ui-ang/icon';
import { BaseClassesModule } from '@backbase/ui-ang/base-classes';
import { FocusModule } from '@backbase/ui-ang/focus';
import { KeyboardClickModule } from '@backbase/ui-ang/keyboard-click-directive';

/**
 * Angular module that provides the {@link SearchBoxComponent} for search input functionality.
 *
 * @remarks
 * This module encapsulates the {@link SearchBoxComponent} and all required dependencies for
 * search input with optional typeahead autocomplete functionality. Import this module to use
 * the search box component in your application.
 *
 * **Dependencies Included**:
 * - {@link SearchBoxComponent} - The main search input component
 * - {@link NgbTypeaheadModule} - ng-bootstrap typeahead for autocomplete
 * - {@link ButtonModule} - Button component for search/clear actions
 * - {@link IconModule} - Icon component for button icons
 * - {@link FormsModule} - Angular forms for two-way binding
 * - {@link BaseClassesModule} - Base input component classes
 * - {@link FocusModule} - Focus directive functionality
 * - {@link KeyboardClickModule} - Keyboard click directive
 *
 * @example
 *
 * ```typescript
 * import { SearchBoxModule } from '@backbase/ui-ang/search-box';
 *
 * @NgModule({
 *   imports: [SearchBoxModule],
 *   // ... rest of module configuration
 * })
 * export class MyFeatureModule {}
 * ```
 *
 * After importing, you can use the search box component in your templates:
 *
 * ```html
 * <bb-search-box-ui
 *   [placeholder]="'Search...'"
 *   [showSearch]="true"
 *   [showClear]="true"
 *   (submit)="onSearch($event)"
 * />
 * ```
 */
@NgModule({
  imports: [
    NgClass,
    NgbTypeaheadModule,
    ButtonModule,
    IconModule,
    FormsModule,
    BaseClassesModule,
    FocusModule,
    KeyboardClickModule,
  ],
  declarations: [SearchBoxComponent],
  exports: [SearchBoxComponent],
})
export class SearchBoxModule {}
